import { invert } from 'lodash';
import { FORM_MODES } from 'config/formModes';

export const FORM_MODE_TO_PATH_MAP = {
    [FORM_MODES.EDIT]: 'edit',
    [FORM_MODES.CREATE]: 'new',
    [FORM_MODES.DUPLICATE]: 'duplicate',
    [FORM_MODES.PREVIEW]: 'preview',
};

export const PATH_TO_FORM_MODE_MAP = invert(FORM_MODE_TO_PATH_MAP);

export const MODE_PARAM_NAME = 'mode';

export const EDIT_ROUTE = `/:${MODE_PARAM_NAME}(${FORM_MODE_TO_PATH_MAP[FORM_MODES.EDIT]})`;
export const NEW_ROUTE = `/:${MODE_PARAM_NAME}(${FORM_MODE_TO_PATH_MAP[FORM_MODES.CREATE]})`;
export const DUPLICATE_ROUTE = `/:${MODE_PARAM_NAME}(${FORM_MODE_TO_PATH_MAP[FORM_MODES.DUPLICATE]})`;
export const PREVIEW_ROUTE = `/:${MODE_PARAM_NAME}(${FORM_MODE_TO_PATH_MAP[FORM_MODES.PREVIEW]})`;

const MODE_PATHS = Object.values(FORM_MODE_TO_PATH_MAP);
export const MODE_PARAM_TEMPLATE = `/:${MODE_PARAM_NAME}(${MODE_PATHS.join('|')})`;
